import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const stepperData = [
  "退職者確認",
  "連絡先の登録",
  "機構への提出確認",
  "機構へ提出",
];

const InfoManual = `次の内容で合算制度利用申出を行います。<
登録内容を確認し、誤りがなければ、機構へ提出ボタンを押してください。<`;

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "契約者（法人）名",
    keyword: "contractorname",
    type: "text",
    showLine: false,
  },
  {
    title: "勤務先",
    keyword: "facilityname",
    type: "text",
  },
  {
    title: "氏名",
    keyword: "staffNamekanji",
    type: "text",
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "text",
  },
  {
    title: "被共済職員期間",
    keyword: "maePerioddate",
    type: "text",
  },
  {
    title: `退職日`,
    keyword: "retiredate",
    type: "text",
  },
  {
    title: "退職理由",
    keyword: "retireProcedurereason",
    type: "text",
  },
  {
    title: "郵便番号",
    keyword: "zipcode",
    type: "text",
  },
  {
    title: "住所",
    keyword: "address",
    type: "text",
  },
  {
    title: "電話番号",
    keyword: "tel",
    type: "text",
  },
  {
    title: "退職者メールアドレス（機構連絡用）",
    keyword: "email",
    type: "text",
  },
  {
    title: "代行者メールアドレス",
    keyword: "agentemail",
    type: "text",
    showLine: false,
  },
  {
    title: "委任状",
    keyword: "powerOfAttorney",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
];

export { InfoManual, stepperData, fakeTableList };
